module.exports = __webpack_public_path__ + "img/coin.f98a1d70.svg";